module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "faq__item"
  }, [_c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "faq__controls"
  }, [_c('div', {
    staticClass: "faq__close",
    class: {
      'faq__close--show': _vm.open
    },
    on: {
      "click": function($event) {
        _vm.open = false
      }
    }
  }, [_c('IconX')], 1)]), _vm._v(" "), _c('div', {
    on: {
      "click": function($event) {
        _vm.open = !_vm.open
      }
    }
  }, [_vm._t("question")], 2), _vm._v(" "), _c('div', {
    staticClass: "faq__answer",
    class: {
      'faq__answer--open': _vm.open
    }
  }, [_vm._t("content")], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-401d5444","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./source/js/components/FaqItem.vue
// module id = 72
// module chunks = 1